<template>
  <div>
    <div class="full-height">
      <v-row justify="center" style="height: 90%">
        <v-col cols="11">
          <v-card
            class="pa-6 my-4"
            width="100%"
            min-height="400"
            raised
            height="100%"
          >
            <div class="d-flex align-center">
              <v-icon color="primary" @click="onClickPrevBtn()"
                >arrow_back</v-icon
              >
              <div class="pl-2 text-h5 primary--text font-weight-medium">
                Work Experience
              </div>
              <v-spacer></v-spacer>
              <v-switch
                v-if="!expLoading"
                inset
                color="primary"
                label="No Work Experience"
                @change="onSkipExperience()"
              ></v-switch>
            </div>
            <div v-if="!expLoading" class="d-flex justify-end">
              <v-btn color="primary" text @click="addMoreExperience()">
                <v-icon>add</v-icon>
                Add Experience
              </v-btn>
            </div>
            <v-form
              v-for="(exp, index) in addExperience"
              :key="index"
              :ref="'expForm' + index"
            >
              <div
                v-if="addExperience.length > 1 || exp.experienceId"
                class="d-flex justify-end mb-3"
              >
                <v-btn
                  color="primary lighten-1"
                  text
                  @click="removeExperience(index, exp)"
                >
                  <v-icon>delete</v-icon>
                  Remove
                </v-btn>
              </div>
              <ValidationObserver :ref="'experienceForm' + index">
                <v-row>
                  <v-col cols="12">
                    <v-card flat class="pa-6">
                      <v-row>
                        <v-col cols="12" lg="4" xl="4" sm="6" md="4" xs="12">
                          <ValidationProvider
                            :ref="'companyNameProvider' + index"
                            v-slot="{ errors }"
                            name="Company Name"
                            rules="required|multilingualNameNumericValidation|min:3"
                          >
                            <v-text-field
                              :id="'CompanyName'"
                              v-model="exp.companyName"
                              outlined
                              :counter="50"
                              :error-messages="errors"
                              label="Company Name*"
                            >
                              <template v-slot:label>
                                Company Name
                                <span style="color: red">*</span>
                              </template>
                            </v-text-field>
                          </ValidationProvider>
                        </v-col>
                        <v-col cols="12" lg="4" xl="4" sm="6" md="4" xs="12">
                          <ValidationProvider
                            :ref="'locationProvider' + index"
                            v-slot="{ errors }"
                            name="Location"
                            rules="required|multilingualNameNumericValidation|min:3"
                          >
                            <v-text-field
                              :id="'Location'"
                              v-model="exp.location"
                              :maxlength="50"
                              outlined
                              :counter="50"
                              label="Location*"
                              :error-messages="errors"
                            >
                              <template v-slot:label>
                                Location
                                <span style="color: red">*</span>
                              </template>
                            </v-text-field>
                          </ValidationProvider>
                        </v-col>
                        <v-col cols="12" lg="4" xl="4" sm="6" md="4" xs="12">
                          <ValidationProvider
                            :ref="'designationProvider' + index"
                            v-slot="{ errors }"
                            name="Designation"
                            rules="required|alphaNumSpaceWithTwoSymbol|min:3"
                          >
                            <v-text-field
                              :id="'Designation'"
                              v-model="exp.designation"
                              outlined
                              :counter="50"
                              label="Designation*"
                              :error-messages="errors"
                            >
                              <template v-slot:label>
                                Designation
                                <span style="color: red">*</span>
                              </template>
                            </v-text-field>
                          </ValidationProvider>
                        </v-col>
                        <v-col cols="12" lg="4" xl="4" sm="6" md="4" xs="12">
                          <v-dialog v-model="exp.fromModal" width="290">
                            <template #activator="{ on }">
                              <ValidationProvider
                                :ref="'fromProvider' + index"
                                v-slot="{ errors }"
                                name="From"
                                rules="required"
                              >
                                <v-text-field
                                  :id="'ExperienceFrom'"
                                  :value="formatDate(exp.from)"
                                  outlined
                                  readonly
                                  label="From*"
                                  v-on="on"
                                  :error-messages="errors"
                                >
                                  <template v-slot:label>
                                    From
                                    <span style="color: red">*</span>
                                  </template>
                                </v-text-field>
                              </ValidationProvider>
                            </template>
                            <v-date-picker
                              v-model="exp.from"
                              :min="minJoinDate"
                              :max="maxYear"
                              @change="emptyTO(index)"
                            ></v-date-picker>
                          </v-dialog>
                        </v-col>
                        <v-col cols="12" lg="4" xl="4" sm="6" md="4" xs="12">
                          <v-dialog v-model="exp.toModal" width="290">
                            <template #activator="{ on }">
                              <ValidationProvider
                                :ref="'toProvider' + index"
                                v-slot="{ errors }"
                                name="To"
                                rules="required"
                              >
                                <v-text-field
                                  :id="'ExperienceTo'"
                                  :value="formatDate(exp.to)"
                                  readonly
                                  outlined
                                  :disabled="!exp.from"
                                  label="To*"
                                  v-on="on"
                                  :error-messages="errors"
                                >
                                  <template v-slot:label>
                                    To
                                    <span style="color: red">*</span>
                                  </template>
                                </v-text-field>
                              </ValidationProvider>
                            </template>
                            <v-date-picker
                              v-model="exp.to"
                              :min="exp.from"
                              :max="maxYear"
                              @change="exp.toModal = false"
                            ></v-date-picker>
                          </v-dialog>
                        </v-col>
                        <!-- Custom Field 1 -->
                        <v-col
                          v-if="
                            getFieldAlias(592) &&
                            getFieldAlias(592).Field_Visiblity == 'Yes'
                          "
                          cols="12"
                          lg="4"
                          xl="4"
                          sm="6"
                          md="4"
                          xs="12"
                        >
                          <ValidationProvider
                            :ref="'customField1Provider' + index"
                            v-slot="{ errors }"
                            :name="getFieldAlias(592).Field_Alias"
                            :rules="
                              getFieldAlias(592).Mandatory_Field == 'Yes'
                                ? `required|min:${
                                    getFieldAlias(592).Min_Validation || 1
                                  }|max:${
                                    getFieldAlias(592).Max_Validation || 100
                                  }|regex:${
                                    getFieldAlias(592).Validation_Id || 5
                                  }`
                                : `min:${
                                    getFieldAlias(592).Min_Validation || 1
                                  }|max:${
                                    getFieldAlias(592).Max_Validation || 100
                                  }|regex:${
                                    getFieldAlias(592).Validation_Id || 5
                                  }`
                            "
                          >
                            <v-text-field
                              :id="'customField1'"
                              v-model="exp.customField1"
                              outlined
                              :counter="
                                getFieldAlias(592).Max_Validation || 100
                              "
                              :maxlength="
                                getFieldAlias(592).Max_Validation || 100
                              "
                              :error-messages="errors"
                            >
                              <template v-slot:label>
                                {{ getFieldAlias(592).Field_Alias }}
                                <span
                                  v-if="
                                    getFieldAlias(592).Mandatory_Field == 'Yes'
                                  "
                                  style="color: red"
                                  >*</span
                                >
                              </template>
                            </v-text-field>
                          </ValidationProvider>
                        </v-col>
                        <v-col cols="12" lg="4" xl="4" sm="12" md="6" xs="12">
                          <DragAndDropFiles
                            :id="'exp' + index"
                            file-category="experience"
                            :old-file-name="exp.fileNameWithoutFormat"
                            :Mandatory="true"
                            :message="true"
                            :is-error="exp.fileValidationError"
                            :key-index="'exp-file-upload-' + index"
                            @file-event-success="updateFileName($event, index)"
                            @file-event-triggered="isFileLoading = $event"
                          />
                        </v-col>
                        <v-col
                          cols="12"
                          v-if="
                            (getFieldAlias(366) &&
                              getFieldAlias(
                                366
                              ).Field_Visiblity.toLowerCase() === 'yes') ||
                            (getFieldAlias(367) &&
                              getFieldAlias(
                                367
                              ).Field_Visiblity.toLowerCase() === 'yes') ||
                            (getFieldAlias(368) &&
                              getFieldAlias(
                                368
                              ).Field_Visiblity.toLowerCase() === 'yes') ||
                            (getFieldAlias(775) &&
                              getFieldAlias(
                                775
                              ).Field_Visiblity.toLowerCase() === 'yes')
                          "
                        >
                          <div
                            class="d-flex justify-space-between align-center mb-3"
                          >
                            <div class="text-h6 font-weight-medium">
                              References
                            </div>
                            <v-btn
                              color="primary pa-0"
                              text
                              @click="addMoreReference(index)"
                            >
                              <v-icon>add</v-icon>Add More
                            </v-btn>
                          </div>
                          <v-form
                            v-for="(reference, rIndex) in exp.addReferences"
                            :key="rIndex"
                            :ref="'languageForm' + rIndex"
                          >
                            <div
                              v-if="exp.addReferences.length > 1"
                              class="d-flex justify-end mb-3"
                            >
                              <v-btn
                                color="primary lighten-1"
                                text
                                @click="removeReference(index, rIndex)"
                              >
                                <v-icon>delete</v-icon>
                                Remove
                              </v-btn>
                            </div>
                            <ValidationObserver
                              :ref="'referencesForm' + rIndex"
                            >
                              <v-row>
                                <v-col
                                  cols="12"
                                  lg="4"
                                  xl="4"
                                  sm="12"
                                  md="6"
                                  xs="12"
                                  v-if="
                                    getFieldAlias(366) &&
                                    getFieldAlias(366).Field_Visiblity == 'Yes'
                                  "
                                >
                                  <ValidationProvider
                                    :ref="'referenceNameProvider' + rIndex"
                                    v-slot="{ errors }"
                                    :name="getFieldAlias(366).Field_Alias"
                                    :rules="
                                      getFieldAlias(366).Mandatory_Field ==
                                      'Yes'
                                        ? 'required|multilingualNameNumericValidation|max:100'
                                        : 'multilingualNameNumericValidation|max:100'
                                    "
                                  >
                                    <v-text-field
                                      :id="'ReferenceName' + rIndex"
                                      v-model="reference.Reference_Name"
                                      outlined
                                      counter="100"
                                      :error-messages="errors"
                                    >
                                      <template v-slot:label>
                                        {{ getFieldAlias(366).Field_Alias }}
                                        <span
                                          v-if="
                                            getFieldAlias(366)
                                              .Mandatory_Field == 'Yes'
                                          "
                                          style="color: red"
                                          >*</span
                                        >
                                      </template>
                                    </v-text-field>
                                  </ValidationProvider>
                                </v-col>
                                <v-col
                                  cols="12"
                                  lg="4"
                                  xl="4"
                                  sm="12"
                                  md="6"
                                  xs="12"
                                  v-if="
                                    getFieldAlias(368) &&
                                    getFieldAlias(368).Field_Visiblity == 'Yes'
                                  "
                                >
                                  <ValidationProvider
                                    :ref="'referenceNumberProvider' + rIndex"
                                    v-slot="{ errors }"
                                    :name="getFieldAlias(368).Field_Alias"
                                    :rules="
                                      getFieldAlias(368).Mandatory_Field ==
                                      'Yes'
                                        ? `required|min:${
                                            getFieldAlias(368).Min_Validation ||
                                            6
                                          }|max:${
                                            getFieldAlias(368).Max_Validation ||
                                            15
                                          }|regex:${
                                            getFieldAlias(368).Validation_Id ||
                                            4
                                          }`
                                        : `min:${
                                            getFieldAlias(368).Min_Validation ||
                                            6
                                          }|max:${
                                            getFieldAlias(368).Max_Validation ||
                                            15
                                          }|regex:${
                                            getFieldAlias(368).Validation_Id ||
                                            4
                                          }`
                                    "
                                  >
                                    <v-text-field
                                      :id="'ReferenceNumber' + rIndex"
                                      v-model="reference.Reference_Number"
                                      outlined
                                      :counter="
                                        getFieldAlias(368).Max_Validation || 15
                                      "
                                      :maxlength="
                                        getFieldAlias(368).Max_Validation || 15
                                      "
                                      :error-messages="[
                                        ...errors,
                                        ...getDuplicatePhoneError(
                                          index,
                                          rIndex
                                        ),
                                      ]"
                                      @input="
                                        validateAndSetDuplicatePhone(
                                          index,
                                          rIndex
                                        )
                                      "
                                    >
                                      <template v-slot:label>
                                        {{ getFieldAlias(368).Field_Alias }}
                                        <span
                                          v-if="
                                            getFieldAlias(368)
                                              .Mandatory_Field == 'Yes'
                                          "
                                          style="color: red"
                                          >*</span
                                        >
                                      </template>
                                    </v-text-field>
                                  </ValidationProvider>
                                </v-col>
                                <v-col
                                  cols="12"
                                  lg="4"
                                  xl="4"
                                  sm="12"
                                  md="6"
                                  xs="12"
                                  v-if="
                                    getFieldAlias(367) &&
                                    getFieldAlias(367).Field_Visiblity == 'Yes'
                                  "
                                >
                                  <ValidationProvider
                                    :ref="'referenceEmailProvider' + rIndex"
                                    v-slot="{ errors }"
                                    :name="getFieldAlias(367).Field_Alias"
                                    :rules="
                                      getFieldAlias(367).Mandatory_Field ==
                                      'Yes'
                                        ? 'required|multilingualNameNumericValidation|email'
                                        : 'multilingualNameNumericValidation|email'
                                    "
                                  >
                                    <v-text-field
                                      :id="'ReferenceEmail' + rIndex"
                                      v-model="reference.Reference_Email"
                                      outlined
                                      :error-messages="[
                                        ...errors,
                                        ...getDuplicateEmailError(
                                          index,
                                          rIndex
                                        ),
                                      ]"
                                      @input="
                                        validateAndSetDuplicateEmail(
                                          index,
                                          rIndex
                                        )
                                      "
                                    >
                                      <template v-slot:label>
                                        {{ getFieldAlias(367).Field_Alias }}
                                        <span
                                          v-if="
                                            getFieldAlias(367)
                                              .Mandatory_Field == 'Yes'
                                          "
                                          style="color: red"
                                          >*</span
                                        >
                                      </template>
                                    </v-text-field>
                                  </ValidationProvider>
                                </v-col>
                                <v-col
                                  cols="12"
                                  lg="4"
                                  xl="4"
                                  sm="12"
                                  md="6"
                                  xs="12"
                                  v-if="
                                    getFieldAlias(775) &&
                                    getFieldAlias(
                                      775
                                    ).Field_Visiblity.toLowerCase() === 'yes'
                                  "
                                >
                                  <ValidationProvider
                                    :ref="
                                      'referencecustomFieldProvider' + rIndex
                                    "
                                    v-slot="{ errors }"
                                    :name="getFieldAlias(775).Field_Alias"
                                    :rules="
                                      getFieldAlias(
                                        775
                                      ).Mandatory_Field.toLowerCase() === 'yes'
                                        ? 'required'
                                        : ''
                                    "
                                  >
                                    <v-text-field
                                      :id="'Reference_Custom_Field_1' + rIndex"
                                      v-model="
                                        reference.Reference_Custom_Field_1
                                      "
                                      :counter="250"
                                      :maxlength="250"
                                      outlined
                                      :error-messages="errors"
                                    >
                                      <template v-slot:label>
                                        {{ getFieldAlias(775).Field_Alias }}
                                        <span
                                          v-if="
                                            getFieldAlias(
                                              775
                                            ).Mandatory_Field.toLowerCase() ===
                                            'yes'
                                          "
                                          style="color: red"
                                          >*</span
                                        >
                                      </template>
                                    </v-text-field>
                                  </ValidationProvider>
                                </v-col>
                              </v-row>
                            </ValidationObserver>
                          </v-form>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                </v-row>
              </ValidationObserver>
              <v-divider></v-divider>
            </v-form>
            <div v-if="!expLoading" class="mt-3 d-flex justify-end">
              <v-btn
                color="primary"
                style="border-radius: 10px"
                large
                :loading="saveLoading"
                :disabled="isFileLoading"
                @click="onSaveExperience()"
                >Save & Continue</v-btn
              >
              <v-btn
                v-if="showSkip"
                class="ml-2"
                elevation="2"
                text
                color="primary"
                style="border-radius: 10px"
                large
                @click="onSkipExperience()"
                >Skip</v-btn
              >
            </div>
            <v-overlay
              absolute
              :value="expLoading || saveLoading"
              color="#fff"
              z-index="1"
            >
              <v-progress-circular
                color="primary"
                indeterminate
                size="50"
              ></v-progress-circular>
            </v-overlay>
          </v-card>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import {
  GET_EXPERIENCE,
  ADD_EXPERIENCE,
  UPDATE_EXPERIENCE,
  DELETE_EXPERIENCE,
} from "@/graphql/OnboardingQueries";
import DragAndDropFiles from "@/components/custom-components/DragAndDropFiles.vue";
import moment from "moment";
import { scrollScreenToTop } from "../../../helper";

export default {
  name: "SkillProfiles",

  components: { DragAndDropFiles },
  props: {
    formList: {
      type: Object,
      required: true,
    },
  },

  data: () => ({
    addExperience: [],
    maxYear: "",
    minJoinDate: "",
    saveLoading: false,
    expLoading: true,
    apiCallCount: 0,
    showSkip: false,
    isFileLoading: false,
    addReferences: [
      {
        Reference_Name: "",
        Reference_Number: "",
        Reference_Email: "",
        Reference_Custom_Field_1: "",
      },
    ],
    duplicateErrors: {}, // Track duplicate validation errors
  }),

  created() {
    let storedDob = localStorage.getItem("DOB");
    if (storedDob && storedDob !== "null") {
      this.minJoinDate = moment(storedDob).format("YYYY-MM-DD");
    }
    this.maxYear = moment().format("YYYY-MM-DD");
  },

  apollo: {
    getExperience: {
      query: GET_EXPERIENCE,
      client: "apolloClientA",
      fetchPolicy: "no-cache",
      variables() {
        return {
          Org_Code: localStorage.getItem("orgCode"),
          Url_Hash: localStorage.getItem("urlHash"),
        };
      },
      result({ data }) {
        if (data && data.getExperience) {
          const { experience } = data.getExperience;
          if (experience && experience.length > 0) {
            let experienceList = [];
            for (let exp of experience) {
              let experienceOnj = {
                companyName: exp.Prev_Company_Name,
                location: exp.Prev_Company_Location,
                designation: exp.Designation,
                from: exp.Start_Date,
                to: exp.End_Date,
                experienceId: exp.Experience_Id,
                fileName: exp.File_Name ? exp.File_Name.split("?")[3] : "",
                fileNameWithoutFormat: exp.File_Name,
                fileValidationError: "",
                fromModal: false,
                toModal: false,
                addReferences:
                  exp.Experience_Reference.length > 0
                    ? exp.Experience_Reference.map((reference) => {
                        return {
                          Reference_Name: reference.Reference_Name,
                          Reference_Number: reference.Reference_Number,
                          Reference_Email: reference.Reference_Email,
                          Reference_Custom_Field_1:
                            reference.Reference_Custom_Field_1,
                        };
                      })
                    : [
                        {
                          Reference_Name: "",
                          Reference_Number: "",
                          Reference_Email: "",
                          Reference_Custom_Field_1: "",
                        },
                      ],
                customField1: exp.Custom_Field_1,
              };
              experienceList.push(experienceOnj);
            }
            this.addExperience = experienceList;
            this.showSkip = true;
          } else {
            this.addExperience.push({
              companyName: "",
              location: "",
              designation: "",
              from: "",
              to: "",
              fileName: "",
              fileNameWithoutFormat: "",
              experienceId: 0,
              fromModal: false,
              toModal: false,
              fileValidationError: "",
              addReferences: [
                {
                  Reference_Name: "",
                  Reference_Number: "",
                  Reference_Email: "",
                  Reference_Custom_Field_1: "",
                },
              ],
              customField1: "",
            });
          }
        }
        this.expLoading = false;
      },
      error() {
        this.expLoading = false;
      },
    },
  },

  computed: {
    formatDate() {
      return (date) => {
        return date ? moment(date).format("DD/MM/YYYY") : "";
      };
    },
  },

  mounted() {
    localStorage.setItem("currentScreen", "1");
    scrollScreenToTop();
  },

  methods: {
    getFieldAlias(fieldId) {
      return this.formList?.[fieldId] || {};
    },
    updateFileName(fileName, index) {
      this.addExperience[index]["fileNameWithoutFormat"] = fileName;
    },

    onClickPrevBtn() {
      this.$emit("back-to-prev");
    },

    addMoreExperience() {
      this.validateExperience().then((isValid) => {
        if (isValid) {
          this.addExperience.push({
            companyName: "",
            location: "",
            designation: "",
            from: "",
            to: "",
            fileName: "",
            fileNameWithoutFormat: "",
            experienceId: 0,
            fileValidationError: "",
            fromModal: false,
            toModal: false,
            addReferences: [
              {
                Reference_Name: "",
                Reference_Number: "",
                Reference_Email: "",
                Reference_Custom_Field_1: "",
              },
            ],
            customField1: "",
          });
        }
      });
    },

    emptyTO(index) {
      this.addExperience[index]["to"] = "";
      this.addExperience[index]["fromModal"] = false;
    },

    validateExperience() {
      return new Promise((resolve) => {
        // First validate all references for duplicates
        for (
          let expIndex = 0;
          expIndex < this.addExperience.length;
          expIndex++
        ) {
          this.revalidateAllReferences(expIndex);
          if (!this.validateAllDuplicateReferenceContacts(expIndex)) {
            resolve(false);
            return;
          }
        }

        // Check if there are any duplicate errors
        const hasDuplicateErrors = Object.values(this.duplicateErrors).some(
          (errors) => errors.length > 0
        );
        if (hasDuplicateErrors) {
          resolve(false);
          return;
        }

        let callCount = 0,
          isValidCount = 0;
        for (let eIndex in this.addExperience) {
          this.$refs["experienceForm" + eIndex][0]
            .validate()
            .then((validationResponse) => {
              let invalidFields = [];
              Object.keys(this.$refs).forEach((refName) => {
                const field = this.$refs[refName];
                if (
                  field &&
                  field.length > 0 &&
                  field[0].errors &&
                  field[0].errors.length > 0
                ) {
                  invalidFields.push(refName);
                }
              });
              if (invalidFields.length > 0) {
                let firstField = this.$refs[invalidFields[0]][0];
                firstField.$el.scrollIntoView({
                  behavior: "smooth",
                  block: "center",
                });
              }
              callCount += 1;
              let eIndexFileName =
                this.addExperience[eIndex]["fileNameWithoutFormat"];
              if (validationResponse && eIndexFileName) {
                isValidCount += 1;
                if (callCount === this.addExperience.length) {
                  resolve(isValidCount === this.addExperience.length);
                }
              } else if (!eIndexFileName) {
                this.addExperience[eIndex]["fileValidationError"] =
                  "Document is required";
                let form = this.$refs["experienceForm" + eIndex][0];
                form.$el.scrollIntoView({
                  behavior: "smooth",
                  block: "center",
                });
                resolve(false);
              }
            });
        }
      });
    },

    onSaveExperience() {
      this.apiCallCount = 0;
      for (let experience of this.addExperience) {
        this.validateExperience().then((isValid) => {
          if (isValid) {
            this.apiCallCount += 1;
            if (experience.experienceId) {
              this.updateExperienceDetails(experience);
            } else {
              this.addExperienceDetails(experience);
            }
          }
        });
      }
    },

    onSkipExperience() {
      this.$emit("experience-saved");
    },

    addExperienceDetails(experienceItem) {
      let vm = this;
      vm.saveLoading = true;
      vm.$apollo
        .mutate({
          mutation: ADD_EXPERIENCE,
          variables: {
            Org_Code: localStorage.getItem("orgCode"),
            Url_Hash: localStorage.getItem("urlHash"),
            Prev_Company_Name: experienceItem.companyName,
            Prev_Company_Location: experienceItem.location,
            Designation: experienceItem.designation,
            Start_Date:
              experienceItem.from && experienceItem.from != "Invalid date"
                ? experienceItem.from
                : null,
            End_Date:
              experienceItem.to && experienceItem.to != "Invalid date"
                ? experienceItem.to
                : null,
            File_Name: experienceItem.fileNameWithoutFormat,
            Reference_Details: experienceItem.addReferences,
            Custom_Field_1: experienceItem.customField1,
          },
          client: "apolloClientA",
        })
        .then(() => {
          if (vm.apiCallCount === vm.addExperience.length) {
            vm.$emit("experience-saved");
          }
        })
        .catch((addErr) => {
          let snackbarData = {
            isOpen: true,
            message:
              addErr.graphQLErrors.length !== 0
                ? addErr.graphQLErrors[0].message
                : "Something went wrong. It could be a possibility due to network connectivity error..",
            type: "warning",
          };
          vm.showAlert(snackbarData);
          if (vm.apiCallCount === vm.addExperience.length) {
            vm.saveLoading = false;
          }
        });
    },

    updateExperienceDetails(experienceItem) {
      let vm = this;
      vm.saveLoading = true;
      vm.$apollo
        .mutate({
          mutation: UPDATE_EXPERIENCE,
          variables: {
            Org_Code: localStorage.getItem("orgCode"),
            Url_Hash: localStorage.getItem("urlHash"),
            Prev_Company_Name: experienceItem.companyName,
            Prev_Company_Location: experienceItem.location,
            Designation: experienceItem.designation,
            Start_Date:
              experienceItem.from && experienceItem.from != "Invalid date"
                ? experienceItem.from
                : null,
            End_Date:
              experienceItem.to && experienceItem.to != "Invalid date"
                ? experienceItem.to
                : null,
            File_Name: experienceItem.fileNameWithoutFormat,
            Experience_Id: experienceItem.experienceId,
            Reference_Details: experienceItem.addReferences,
            Custom_Field_1: experienceItem.customField1,
          },
          client: "apolloClientA",
        })
        .then(() => {
          if (vm.apiCallCount === vm.addExperience.length) {
            vm.$emit("experience-saved");
          }
        })
        .catch((addErr) => {
          let snackbarData = {
            isOpen: true,
            message:
              addErr.graphQLErrors.length !== 0
                ? addErr.graphQLErrors[0].message
                : "Something went wrong. It could be a possibility due to network connectivity error..",
            type: "warning",
          };
          vm.showAlert(snackbarData);
          if (vm.apiCallCount === vm.addExperience.length) {
            vm.saveLoading = false;
          }
        });
    },

    removeExperience(index, experienceItem) {
      if (experienceItem.experienceId) {
        let vm = this;
        this.$apollo
          .mutate({
            mutation: DELETE_EXPERIENCE,
            variables: {
              Org_Code: localStorage.getItem("orgCode"),
              Url_Hash: localStorage.getItem("urlHash"),
              Experience_Id: experienceItem.experienceId,
            },
            client: "apolloClientA",
          })
          .then(() => {
            let snackbarData = {
              isOpen: true,
              message: "Deleted Successfully",
              type: "success",
            };
            vm.showAlert(snackbarData);
            vm.addExperience.splice(index, 1);
            if (index === 0 && vm.addExperience.length === 0) {
              vm.addExperience.push({
                companyName: "",
                location: "",
                designation: "",
                from: "",
                to: "",
                fileName: "",
                fileNameWithoutFormat: "",
                experienceId: 0,
                customField1: "",
              });
            }
          })
          .catch((deleteErr) => {
            let snackbarData = {
              isOpen: true,
              message:
                deleteErr.graphQLErrors.length !== 0
                  ? deleteErr.graphQLErrors[0].message
                  : "Something went wrong. It could be a possibility due to network connectivity error..",
              type: "warning",
            };
            vm.showAlert(snackbarData);
          });
      } else {
        this.addExperience.splice(index, 1);
      }
    },

    // show error or success message
    showAlert(snackbarData) {
      this.$store.commit("OPEN_SNACKBAR", snackbarData);
    },
    addMoreReference(index) {
      this.validateReferences().then((isValid) => {
        if (isValid) {
          this.addExperience[index].addReferences.push({
            Reference_Name: "",
            Reference_Number: "",
            Reference_Email: "",
            Reference_Custom_Field_1: "",
          });
          // Revalidate all references to check for duplicates
          this.revalidateAllReferences(index);
        }
      });
    },
    validateReferences() {
      return new Promise((resolve) => {
        let callCount = 0,
          isValidCount = 0;
        for (let aIndex in this.addReferences) {
          this.$refs["referencesForm" + aIndex][0]
            .validate()
            .then((validationResponse) => {
              callCount += 1;
              if (validationResponse) {
                isValidCount += 1;
                if (callCount === this.addReferences.length) {
                  resolve(isValidCount === this.addReferences.length);
                }
              }
            });
        }
      });
    },
    removeReference(index, rIndex) {
      this.addExperience[index].addReferences.splice(rIndex, 1);

      // Clear all duplicate errors for this experience and revalidate
      // This is necessary because removing a reference changes the indices
      // and we need to clean up any stale error keys
      this.revalidateAllReferences(index);
    },

    validateDuplicateReferenceContact(type, value, expIndex) {
      if (!value || !value.trim()) {
        return true; // No validation needed for empty values
      }

      const references = this.addExperience[expIndex]?.addReferences;
      const fieldName =
        type === "email" ? "Reference_Email" : "Reference_Number";

      // Count occurrences of the same value in the references
      const duplicateCount = references.filter((ref) => {
        if (!ref[fieldName]) return false;

        if (type === "email") {
          return (
            ref[fieldName].trim().toLowerCase() === value.trim().toLowerCase()
          );
        } else {
          return ref[fieldName].trim() === value.trim();
        }
      }).length;

      if (duplicateCount > 1) {
        // Get field labels from getFieldAlias
        const emailFieldLabel =
          this.getFieldAlias(367)?.Field_Alias || "Reference Email";
        const phoneFieldLabel =
          this.getFieldAlias(368)?.Field_Alias || "Reference Number";

        if (type === "email") {
          return `You cannot use the same ${emailFieldLabel.toLowerCase()} more than once for the same work experience. Please update the details.`;
        } else {
          return `You cannot use the same ${phoneFieldLabel.toLowerCase()} more than once for the same work experience. Please update the details.`;
        }
      }

      return true;
    },

    validateAllDuplicateReferenceContacts(expIndex) {
      const references = this.addExperience[expIndex]?.addReferences;
      const emails = [];
      const phones = [];

      for (const reference of references) {
        // Check for duplicate emails
        if (reference.Reference_Email && reference.Reference_Email.trim()) {
          const email = reference.Reference_Email.trim().toLowerCase();
          if (emails.includes(email)) return false;
          emails.push(email);
        }

        // Check for duplicate phone numbers
        if (reference.Reference_Number && reference.Reference_Number.trim()) {
          const phone = reference.Reference_Number.trim();
          if (phones.includes(phone)) return false;
          phones.push(phone);
        }
      }
      return true;
    },

    // Get duplicate error for phone field
    getDuplicatePhoneError(expIndex, refIndex) {
      const key = `phone_${expIndex}_${refIndex}`;
      return this.duplicateErrors[key] || [];
    },

    // Get duplicate error for email field
    getDuplicateEmailError(expIndex, refIndex) {
      const key = `email_${expIndex}_${refIndex}`;
      return this.duplicateErrors[key] || [];
    },

    // Validate and set duplicate errors for phone
    validateAndSetDuplicatePhone(expIndex) {
      // Revalidate all references to ensure proper error state management
      // This ensures that when a duplicate is fixed, all related errors are cleared
      this.revalidateAllReferences(expIndex);
    },

    // Validate and set duplicate errors for email
    validateAndSetDuplicateEmail(expIndex) {
      // Revalidate all references to ensure proper error state management
      // This ensures that when a duplicate is fixed, all related errors are cleared
      this.revalidateAllReferences(expIndex);
    },

    // Clear all duplicate errors for a specific experience
    clearExperienceErrors(expIndex) {
      Object.keys(this.duplicateErrors).forEach((key) => {
        if (
          key.startsWith(`phone_${expIndex}_`) ||
          key.startsWith(`email_${expIndex}_`)
        ) {
          this.$delete(this.duplicateErrors, key);
        }
      });
    },

    // Revalidate all references in an experience
    revalidateAllReferences(expIndex) {
      const references = this.addExperience[expIndex]?.addReferences;

      // First, clear all existing errors for this experience
      this.clearExperienceErrors(expIndex);

      // Then validate each field and set errors if needed
      for (let i = 0; i < references.length; i++) {
        const reference = references[i];

        // Validate phone
        if (reference.Reference_Number && reference.Reference_Number.trim()) {
          const phoneResult = this.validateDuplicateReferenceContact(
            "phone",
            reference.Reference_Number,
            expIndex
          );
          if (phoneResult !== true) {
            const phoneKey = `phone_${expIndex}_${i}`;
            this.$set(this.duplicateErrors, phoneKey, [phoneResult]);
          }
        }

        // Validate email
        if (reference.Reference_Email && reference.Reference_Email.trim()) {
          const emailResult = this.validateDuplicateReferenceContact(
            "email",
            reference.Reference_Email,
            expIndex
          );
          if (emailResult !== true) {
            const emailKey = `email_${expIndex}_${i}`;
            this.$set(this.duplicateErrors, emailKey, [emailResult]);
          }
        }
      }
    },
  },
};
</script>
